<script>
    import PlanetaryIntroScene from "./Scenes/PlanetaryIntroScene.svelte";
    import Background from "./Scenes/Background.svelte";
    import TelescopeLightHouseScenes from "./Scenes/TelescopeLightHouseScenes.svelte";
    import NineLeadersScene from "./Scenes/NineLeadersScene.svelte";
    import PathScene from "./Scenes/PathScene.svelte";
    import MagnifyingGlass from "./pre-comps/Elements/MagnifyingGlass.svelte";
    import ThreeLeaders from "./pre-comps/Elements/ThreeLeaders.svelte";
    import Building from "./pre-comps/Elements/Building.svelte";
    import CircleScene from "./Scenes/CircleScene.svelte";
    import Boxes from "./pre-comps/Boxes.svelte";
    import PointerDrop from "./pre-comps/Elements/PointerDrop.svelte";
    import IntroPart2 from "./Scenes/IntroPart2.svelte";
    import BoxTooltip from "./pre-comps/BoxTooltip.svelte";
    import CustomerJourneyLabels from "./pre-comps/Elements/CustomerJourneyLabels.svelte";
    import Gnosis from "./pre-comps/Gnosis.svelte";

    export let scene = 0;
    export let audioMuted = false;

</script>


<svg width="100%" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1920 1000" overflow="visible">
  <Background />
  <PlanetaryIntroScene />
  <IntroPart2 {scene} />
  <Gnosis {audioMuted} />
  <BoxTooltip />
  <TelescopeLightHouseScenes />
  <NineLeadersScene />
  <PathScene />
  <Boxes {scene}/>
  <PointerDrop />
  <MagnifyingGlass />
  <ThreeLeaders />
  <Building />
  <CircleScene />
  <CustomerJourneyLabels on:go-to-scene {scene}/>
</svg>

